import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { FaxFileTypeOption } from '../models/fax-file-type-option.interface';
import { faxFileTypeOptionActions } from '../state/fax-file-type-option.actions';
import { faxFileTypeOptionSelectors } from '../state/fax-file-type-option.reducer';

@Directive({
    selector: '[ndtFaxFileTypeSelect]',
    standalone: false
})
export class FaxFileTypeSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<FaxFileTypeOption>,
      private statusService: NgrxEagerSelectService<AppState, FaxFileTypeOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] | undefined;

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            faxFileTypeOptionActions,
            faxFileTypeOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('faxFileTypeId', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
